import React from 'react';
import {
  ModalOverlay,
  ModalContent,
  Title,
  Message,
  ButtonGroup,
  Button
} from './styles';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message,
  actionButtonText = 'Delete',
  actionButtonColor,
  style 
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose} data-modal-overlay="true">
      <ModalContent onClick={e => e.stopPropagation()} style={style}>
        <Title>{title}</Title>
        <Message>{message}</Message>
        <ButtonGroup>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={onConfirm}
            $color={actionButtonColor}
          >
            {actionButtonText}
          </Button>
        </ButtonGroup>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ConfirmationModal; 